import { render, staticRenderFns } from "./ComponentCosts.vue?vue&type=template&id=e7952bcc&scoped=true"
import script from "./ComponentCosts.vue?vue&type=script&lang=ts"
export * from "./ComponentCosts.vue?vue&type=script&lang=ts"
import style0 from "./ComponentCosts.vue?vue&type=style&index=0&id=e7952bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7952bcc",
  null
  
)

export default component.exports